import React, { useReducer, useEffect, useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';

import Quotes from '../common/Quotes';
import SelectedPoliciesDispatch from '../../contexts/selectedPolicies.dispatch';
import selectedPolicesReducer from '../../reducers/selectedPolices.reducer';
import AlertDispatch from '../../contexts/alert.dispatch';
import alertActions from '../../actions/alert.actions';

import style from './PolicyDocumentRequestPage.module.css';

const ProposalComparisonRequestPage = React.memo(({ clientId }) => {
  const alertDispatch = useContext(AlertDispatch);
  const [submitted, setSubmitted] = useState(false);
  const [selectedQuotesState, selectedQuotesDispatch] = useReducer(
    selectedPolicesReducer,
    {
      ids: [],
    },
  );

  useEffect(() => {
    const handleSuccess = () => {
      alertDispatch({
        type: alertActions.SUCCESS,
        message:
          'Thank you for your request. A member of your dedicated team will respond within 1 business day.',
      });
      setSubmitted(true);
    };

    if (selectedQuotesState.ids.length > 0) {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}hub/clients/${clientId}/requests/proposal-comparison`,
          selectedQuotesState.ids,
        )
        .then(handleSuccess);
    }
  }, [alertDispatch, clientId, selectedQuotesState.ids]);

  return !submitted ? (
    <SelectedPoliciesDispatch.Provider value={selectedQuotesDispatch}>
      <div className={style.main}>
        <h1 className={style.title}>Request Proposal Comparison</h1>
        <span className={style.hint}>
          Select the quotes to include in the proposal comparison (Max. three)
        </span>
        <Quotes clientId={clientId} />
      </div>
    </SelectedPoliciesDispatch.Provider>
  ) : (
    <Redirect to={`/clients/${clientId}`} />
  );
});

ProposalComparisonRequestPage.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default ProposalComparisonRequestPage;
